import React, {  useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Accordion, AccordionSummary, AccordionDetails, Typography, Box} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';

import TextLinkButton from "../../Layout/TextLinkButton"
import NetworkScanTable from '../../Networks/NetworkScanTable';
import Networks from '../../Networks/Networks';
import GenericActionButton from '../../Layout/GenericActionButton';

function GwNetworksSection({ gatewayId }) {

    const navigate = useNavigate();

    const networksColumns = [
        { id: 'networkId', label: 'Network ID', filtered: true,
             render: (item) => <TextLinkButton action={() =>handleNetSelect(item.networkId)} text={`${item.networkNumber}:${item.networkSerial}`}/>},
        { id: 'networkDescription', label: 'Network Description', filtered: true},
        { id: 'nodeCount', label: 'Nodes' },
        { id: 'meterCount', label: 'Meters' },
        { id: 'errorCodes', label: 'Status', filtered: true,  render: (item) => renderNetStatus(item.errorCodes) },
        { id: 'lastConnect', label: 'Last Connection',  render: (item) => formatDateTime(item.lastConnect) }
    ];

    const formatDateTime = (isoString) => {
        const date = new Date(isoString);
    
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const year = date.getFullYear();
    
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
    
        return `${day}/${month}/${year}, ${hours}:${minutes}:${seconds}`;
    };

    const handleNetSelect = async (networkId) => {
        navigate(`/networks/${networkId}`);
    };

    const renderNetStatus = (dataType) => {
        const errorCodes = {
            "40": "Failure",
            "136": "Permanent communications error",
            "144": "Temporary communications error"
        };

        const codes = dataType.split(',');

        // Check if the only code is "0"
        if (codes.length === 1 && codes[0] === "0") {
            return "OK";
        }

        const translations = codes.filter(code => code !== "0").map(code => errorCodes[code]);
        // Join the translations with a comma and return the result
        return translations.join(', ');
    };

    useEffect(() => {
      
    }, [gatewayId]);


    return (
        <>
            <Accordion defaultExpanded={false}>
                <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant="h7">NETWORKS</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Box display="flex" justifyContent="space-between" alignItems="center" marginBottom="10px">
                        <Typography variant="h8">List of network with configured readings</Typography>
                        <GenericActionButton
                            actions={[
                                { label: 'Networks Scan', onClick: () => navigate(`/gateways/${gatewayId}/scan/networks`) },
                                { label: 'Networks Readouts', onClick: () => navigate(`/gateways/${gatewayId}/readouts`) }
                            ]}
                        />
                    </Box>
                    <Box mb={{ xs: 2, sm: 3, md: 4 }}>
                        <Networks 
                            fetchRoute={`/net/listByGw/${gatewayId}`}
                            disableBreadcrumb={true}
                            customColumns={networksColumns}
                        />
                    </Box>
                    <Box mb={{ xs: 2, sm: 3, md: 4 }}>
                    <Typography variant="h8">List of scanned network</Typography>
                    </Box>
                    <Box mb={{ xs: 2, sm: 3, md: 4 }}>
                        <NetworkScanTable
                            gatewayId={gatewayId}
                        />
                    </Box>
                
                </AccordionDetails>
            </Accordion>
        </>     
    );
}

export default GwNetworksSection;
